/** Word- or line-level timing segment inside a {@link Cue}. */
export type CueSeg = {
  start: number;
  end: number;
  text: string;
};

/**
 * Unified subtitle cue contract (ANALYSIS §1b.2E).
 * Times are milliseconds.
 */
export type Cue = {
  start: number;
  end: number;
  text: string;
  segs: CueSeg[];
  lang?: string;
  translated?: boolean;
  translation?: string;
  loading?: boolean;
  restored?: boolean;
  info?: boolean;
  dictation?: string;
  kuroshiro?: string;
  src?: string;
  extent?: { h: number; v: number } | null;
  origin?: { h: number; v: number } | null;
  preprocessed?: boolean;
};

export function createTextCue(start: number, end: number, text: string, segs: CueSeg[]): Cue {
  return { start, end, text, segs };
}

export function createImageCue(
  start: number,
  end: number,
  src: string,
  extent: { h: number; v: number } | null,
  origin: { h: number; v: number } | null,
): Cue {
  return {
    start,
    end,
    src,
    text: '',
    extent,
    origin,
    translated: true,
    translation: '',
    segs: [],
  };
}
